const es = global.es; // TODO Remove dependency

export default class PolygonStyleTypeUtil {
    /**
     * 
     * @param style 
     * @param geom 
     * @param point 
     * @param resolution 
     * 
     * @returns 
     */
    containsPoint(style, geom, point, resolution): boolean {
        let ret = false;
        es.api.geom.extractLines(geom, (array, startIndex, endIndex) => { // Do a point in polygon test using ray casting...
            let ax = array[startIndex++];
            let ay = array[startIndex++];
            
            while (startIndex < endIndex) {
                const bx = array[startIndex++];
                const by = array[startIndex++];
                
                //now we have a line segment ax,ay -> bx,by : Test does it cross a semi infinite ray...
                if (((by>point[1]) !== (ay > point[1])) && (point[0] < (ax - bx) * (point[1] - by) / (ay - by) + bx)) {
                    ret = !ret;
                }
                
                ax = bx;
                ay = by;
            }
        });

        return ret;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getColor(style) {
        return style.fillColor != null ? style.fillColor : style.line.color;
    }
    
    /**
     * 
     * @param style 
     * @param color 
     * 
     * @returns 
     */
    withColor(style, color) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        
        style.fillColor = color;
        
        // if(style.text){
        //     if(style.text.$type !== "Label"){ // Labels do not get teir Alpha reset.
        //         var alpha = es.util.color.getAlpha(color);
        //         if(style.text.color != null){ // BasicText
        //             style.text.color = es.util.color.withAlpha(style.text.color, alpha);
        //         }
        //     }
        // }
        
        return style;   
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    mainColor(style) {
        return this.getColor(style);
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getPaddingPx(style): number[] {
        var x,y;
        x = y = style.line ? style.line.width : 0;

        if (isNaN(x) || isNaN(y)) {
            es.log.error('Invalid coordinates x [' + x + '] y [' + y + ']');
        }

        return [x, y];
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getText(style) {
        return style.text;
    }

    /**
     * 
     * @param style 
     * @param geom 
     * @param pnt 
     * 
     * @returns 
     */
    getFocalPoint(style, geom, pnt) {
        if (!geom) {
            return pnt;
        }

        var bounds = this.getFocalBounds(style, geom);
        pnt = [(bounds[0] + bounds[2]) / 2, (bounds[1] + bounds[3]) / 2];
        return pnt;
    }
    
    /**
     * 
     * @param style 
     * @param geom 
     * 
     * @returns 
     */
    getFocalBounds(style, geom) {
        var bounds;
        if(geom[0] === "MP"){ // If multi polygon, find the largest ring
            var area = -1;
            for(var g = geom.length; g-- > 1;){
                var b = es.util.bounds.valueOf(geom[g][0]);
                var a = es.util.bounds.area(b);
                if(a > area){
                    area = a;
                    bounds = b;
                }
            }
        }else{
            bounds = es.api.geom.getBounds(geom);
        }
        return bounds;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasDirect(style): boolean {
        return true;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasOverlays(style): boolean {
        return !!(style.text);
    }
}
